import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BuscarPersonaPlantilla } from "../Modelos/BuscarPersonaPlantilla";
import { Poliza } from "../Modelos/Poliza";
import { Amparo } from "../Modelos/Amparo";
import { ResponseApiPrintingI } from "../Modelos/ResponseApiPrinting";
import { Persona, Participante } from "../Modelos/Persona";
import { PersonaGobernabilidad } from "../Modelos/PersonaGobernabilidad";

import {
  HttpClient,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { RiskRequest } from "../Modelos/RiskService/RiskRequest";
import { ValidacionExclusionRequestDto, ValidacionExclusionResponse } from "../Modelos/ValidacionExclusionRequestDto";

export class Parametro {
  llave: string;
  valor: string;
}

@Injectable({
  providedIn: "root",
})
export class PolizaService {
  respuesta: BehaviorSubject<ResponseApiPrintingI> = new BehaviorSubject(null);
  encryptInfo;
  decryptedInfo;
  url: string = environment.backendUrl;
  apiUrlValidate: string = environment.validacionExclusion;

  prod = environment.production;

  private _todos = new BehaviorSubject<any[]>([]);
  private tokenAPIRisk: string = "";
  private dataStore: { todos: any } = { todos: [] };
  readonly todos = this._todos.asObservable();
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "X-XSS-Protection": "1;mode=block",
      p: "SAMEORIGIN",
      "Content-Security-Policy": "script-src 'self'",
      "X-Content-Type-Options": "nosniff",
    }),
  };
  constructor(private http: HttpClient) {}
  loadAll(api) {
    this.http.get(`${this.url}/${api}`, this.httpOptions).subscribe(
      (data) => {
        this.dataStore.todos = data;
        this._todos.next(Object.assign({}, this.dataStore).todos);
      },
      (error) => console.log("Could not load todos.")
    );
  }

  async resolverPeticion(endpoint: string, parametros: Parametro[] = []) {
    let url = new URL(`${environment.backendUrl}/api/${endpoint}`);
    parametros.forEach((parametro) =>
      url.searchParams.append(parametro.llave, parametro.valor)
    );
    // console.log("ver url",url)
    return await (await fetch(url.toString(), { method: "GET" })).json();
  }

  consultarRamos() {
    return this.resolverPeticion("ramo");
  }

  consultarAgencias(
    filtrarAgencias: boolean = false,
    parametros: Parametro[] = []
  ) {
    if (!filtrarAgencias)
      return this.resolverPeticion("agencia", [
        { llave: "cod_zona", valor: "29" },
      ]);
    else return this.resolverPeticion("sucursal", parametros);
  }

  async consultarTiposDocumento() {
    let url = `${environment.backendUrl}/api/tipoDocumento`;
    let object = await (await fetch(url, { method: "GET" })).json();
    return object;
  }

  async consultarPersonaUnParametro(primerApellido: string) {
    let url = new URL(`${environment.backendUrl}/api/terceroAfectado`);
    let parameters = {
      apellido: primerApellido,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async enviarCorreo(correo: string, correoCC: string){
    let url = new URL(
      `${environment.backendUrl}/api/ClsUsuario/EnvioNotificacion`
    );
    let parameters = {
      Correo: correo,
      CorreoCC: correoCC,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  async uploadMultipleFiles(payload: any, usuario: string = "") {
    
    let url=`${environment.backendUrl}/api/ClsUsuario/EnvioDocumentoFucc?usuario=${usuario}`;
  
    let json=JSON.stringify(payload);

    let request: RequestInit={
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        method: 'POST',
        body: json
    };

    return await (await fetch(url, request)).json();
  }

  async uploadMultipleFilesAutos(payload: any, usuario: string = "") {    
    let url=`${environment.backendUrl}/api/ClsUsuario/EnvioDocumentoFuccAutos?usuario=${usuario}`;  
    let json=JSON.stringify(payload);
    let request: RequestInit={
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        method: 'POST',
        body: json
    };
    return await (await fetch(url, request)).json();
  }


  async consultarPersona(persona: BuscarPersonaPlantilla) {
    let url = new URL(
      `${environment.backendUrl}/api/ClsUsuario/ConsultaUsuario`
    );
    let parameters = {
      InId_Aplicacion: environment.applicationId,
      InTipoDocumento: persona.tipoDocumento,
      StrNroDocumento: persona.numeroDocumento,
      StrPrimerApellido: persona.primerApellido,
      InIdPersona: persona.idPersona == 0 ? "" : persona.idPersona,
      CrTipoPersona: persona.tipoPersona,
      InCodRamo: persona.ramo,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async ConsultarAutorizacionUsuario(persona: BuscarPersonaPlantilla) {
    let url = new URL(
      `${environment.backendUrl}/api/ClsUsuario/ConsultarAutorizacionUsuario`
    );
    let parameters = {
      InId_Aplicacion: environment.applicationId,
      InTipoDocumento: persona.tipoDocumento,
      StrNroDocumento: persona.numeroDocumento,
      StrPrimerApellido: persona.primerApellido,
      InIdPersona: persona.idPersona == 0 ? "" : persona.idPersona,
      CrTipoPersona: persona.tipoPersona,
      InCodRamo: persona.ramo,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async consultarPuntosVenta(codigoAgencia: number, codigoUsuarioSISE: string) {
    let url = new URL(
      `${environment.backendUrl}/api/Pto_vta/ConsultarPuntoVentaxUsuario`
    );
    let parameters = {
      codsucursal: codigoAgencia,
      codusuario: codigoUsuarioSISE,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async consultarCupoOperativo(codigoAsegurador, codigoRamo) {
    let url = new URL(
      `${environment.backendUrl}/api/CupoOperativo/ConsultarCupo`
    );
    let parameters = {
      cod_asegurador: codigoAsegurador,
      cod_ramo: codigoRamo == null ? 0 : codigoRamo,
      cod_moneda: 0,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async modificarCupoOperativo(
    codigoAsegurador,
    codigoRamo,
    cupoNuevo,
    codigoUsuario,
    fechaCupovigenciahasta : string
  ) {
    let url = new URL(
      `${environment.backendUrl}/api/CupoOperativo/ModificarCupo`
    );
    let parameters = {
      cod_asegurador: codigoAsegurador,
      cod_ramo: codigoRamo == null ? 0 : codigoRamo,
      imp_cupo_nuevo: cupoNuevo,
      cod_usuario: codigoUsuario,
      cod_moneda: 0,
      fechaCupovigenciahasta : fechaCupovigenciahasta
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async duplicarPersona(idPersona, apellido) {
    let url = new URL(`${environment.backendUrl}/api/duplicarPersona`);
    let parameters = {
      id_persona: idPersona,
      apellido: apellido,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async consultarGastosExpedicion(
    codRamo: number,
    codSucursal: number,
    codTipoAgente: number,
    codAgente: number
  ) {
    let url = new URL(`${environment.backendUrl}/api/gastos`);
    let parameters = {
      cod_ramo: codRamo,
      cod_sucursal: codSucursal,
      cod_tipoagente: codTipoAgente,
      cod_agente: codAgente,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async consultarActividadesEconomicas() {
    let url = `${environment.backendUrl}/api/actividadEconomica`;
    let object = await (await fetch(url, { method: "GET" })).json();
    return object;
  }

  async consultarOcupaciones() {
    let url = new URL(`${environment.backendUrl}/api/ocupacion`);
    let parameters = {
      codMacroRamo: 1,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async consultarDepartamentos() {
    let url = `${environment.backendUrl}/api/departamento`;
    let object = await (await fetch(url, { method: "GET" })).json();
    return object;
  }

  async consultarMunicipios(codigoDepartamento: number = 1) {
    let url = new URL(`${environment.backendUrl}/api/municipio`);
    let parameters = {
      id_departamento: codigoDepartamento,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async consultarEstadosCiviles() {
    let url = `${environment.backendUrl}/api/estadoCivil`;
    let object = await (await fetch(url, { method: "GET" })).json();
    return object;
  }

  async consultarCorrelativa(
    codigoRamo: number,
    codigoSucursal: number,
    numeroPoliza: number
  ) {
    let url = new URL(`${environment.backendUrl}/api/correlativa`);
    let parameters = {
      cod_ramo: codigoRamo,
      cod_suc: codigoSucursal,
      nro_pol: numeroPoliza,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    if (object.length != 0) {
      return object[0];
    }
    return null;
  }

  async crearPersona(persona) {
    let request: RequestInit = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
      },
      method: "POST",
      body: persona,
    };
    let url = `${environment.backendUrl}/api/ClsUsuario/CreacionPersona`;
    let object = await (await fetch(url, request)).json();
    return object;
  }

  async emitirPoliza(emision: Poliza) {
    let fechaCreacion = new Date().toLocaleString("es-CO", { hour12: false });

    let poliza = {
      NmCodProducto: 1, //Por definir
      NmNroPoliza: 1000, //Por definir
      InCodUsuario: 12, //Por definir
      NmPjeIva: 19.0, //Por definir
      InNroConst: 3, //OSCAR
      InCodTipoPoliza: 1, //OSCAR
      InCodOperacion: 1, //Siempre va a ser 1
      InCodGrupoEndo: 1, //Siempre va a ser 1
      InCodTipoEndo: 1, //Siempre va a ser 1
      InCodTipoMoneda: 0, //Siempre va a ser 0 (Pesos) Informar en modal
      InCodGrupo: null, //Siempre va a ser null
      NmCodPlanPago: 1, //Va asociado al tomador, siempre va a ser 1
      NmCodConducto: 1, //Va asociado al tomador, siempre va a ser 1
      InEstadoProceso: 1,
      InCodZona: 29,
      Inproceso_correlativo: emision.codigoProceso,
      Cod_usuarioSISE: emision.codigoUsuarioSISE,
      SdFecConst: fechaCreacion,
      NmCodSucursal: parseInt(emision.agencia.toString()),
      NmCodPtoVta: parseInt(emision.puntoVenta.toString()),
      NmCodRamo: parseInt(emision.ramo.toString()),
      InCodTipoCliente: parseInt(emision.tipoCliente.toString()),
      NmValorContrato: this.extraerNumero(emision.producto.valorContrato),
      SnSeriedadOferta: emision.seriedadDeLaOferta ? -1 : 0,
      InCodTipoAgente: emision.intermediarios[0].cod_tipo_inter, //Código tipo intermediario
      InCodAgente: parseInt(emision.intermediarios[0].clave), //Clave intermediario
      SdFecCreacion: fechaCreacion,
      SdFecEmision: emision.producto.fechaExpedicion,
      SdFecVigDesde: emision.producto.fechaVigenciaDesde, //Fecha Vigencia Desde
      SdFecVigHasta: this.obtenerFechaVigenciaHasta(emision.producto.amparos), //Fecha del amparo con la vigencia más futura (Front)
      InCodClausulado: parseInt(emision.producto.clausulado.toString()),
      InCodObjeto: parseInt(emision.producto.objetoContrato.toString()),
      VcTextoProceso: emision.textoAclaratorio, //Texto Aclaratorio
      NmPjeGastosEmision: this.extraerNumero(emision.gastosEmision),
      NmValorSeguro: this.extraerNumero(emision.totalPrimaNeta),
      NmCodGiroNegocio: parseInt(emision.producto.giroNegocio.toString()),
      VcNroLicitacion: emision.producto.numeroContrato,
      SdFecFinContrato: emision.producto.fechaFinConstitucion,
      InCodDepto:
        emision.CodigoDepartamento == null
          ? 0
          : parseInt(emision.CodigoDepartamento.toString()),
      InCodMunicipio:
        emision.CodigoMunicipio == null
          ? 0
          : parseInt(emision.CodigoMunicipio.toString()),
      Personas: this.obtenerPersonas(emision),
      Amparos: this.obtenerAmparos(emision),
      Intermediarios: this.obtenerIntermediarios(emision),
    };

    let json = JSON.stringify(poliza);

    console.log(`%c ${json}`, "background-color: #FFA319; color: black");

    let request: RequestInit = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
      },
      method: "POST",
      body: json,
    };
    let url = `${environment.backendUrlEmision}/api/CrearTemporario`;
    let object = await (await fetch(url, request)).json();
    return object;
  }

  extraerNumero(valor: string) {
    return parseFloat((!valor ? "0" : valor).replace(/,/g, ""));
  }

  obtenerFechaVigenciaHasta(amparos: Amparo[]) {
    let fechaMaxima = new Date(0, 0, 0);
    amparos.forEach((x) => {
      let fecha = x.fecha_vigencia_hasta.split("/").map((x) => parseInt(x));
      let fechaHasta = new Date(fecha[2], fecha[1] - 1, fecha[0]);
      if (fechaHasta > fechaMaxima) {
        fechaMaxima = fechaHasta;
      }
    });
    return fechaMaxima.toLocaleDateString("es-CO", {});
  }

  obtenerPersonas(emision: Poliza) {
    let personas = emision.participantes.map((x) => {
      return {
        InFiguraPersona: 2, //1: Asegurado, 2: Tomador, 3: Beneficiario
        InCodAseg: x.codigoAsegurado,
        InCodPersona: x.idPersona,
        NmCodTipoDoc: x.tipoDocumento,
        VcNroDoc: x.numeroDocumento.toString(),
        VcPrimerApellido: x.apellidoUno,
        SdFecExpDoc: "",
        SnPerPrincipal: 0, // 0 -> false, -1 -> true
        NmPjeParticipa: x.porcentajeParticipacion,
        NmVlrCupo:
          x.cupoOperativo == null
            ? 0
            : this.extraerNumero(x.cupoOperativo.toString()),
      };
    });

    let asegurado = emision.asegurado;
    personas.push({
      InFiguraPersona: 1, //Asegurado
      InCodAseg: asegurado.codigoAsegurado,
      InCodPersona: asegurado.idPersona,
      NmCodTipoDoc: asegurado.tipoDocumento,
      SdFecExpDoc: asegurado.fechaExpedicion,
      NmPjeParticipa: 0,
      NmVlrCupo: 0,
      SnPerPrincipal: 0,
      VcNroDoc: asegurado.numeroDocumento.toString(),
      VcPrimerApellido: asegurado.apellidoUno,
    });

    let tomador = emision.tomador;
    personas.push({
      InFiguraPersona: 2, //Tomador
      InCodAseg: tomador.codigoAsegurado,
      InCodPersona: tomador.idPersona,
      NmCodTipoDoc: tomador.tipoDocumento,
      SdFecExpDoc: tomador.fechaExpedicion,
      NmPjeParticipa: 0,
      NmVlrCupo: this.extraerNumero(tomador.cupoDisponible),
      SnPerPrincipal: -1,
      VcNroDoc: tomador.numeroDocumento.toString(),
      VcPrimerApellido: tomador.apellidoUno,
    });

    let beneficiario = emision.beneficiario;
    if (emision.ramo == 74) beneficiario = emision.beneficiario;
    else beneficiario = emision.asegurado;

    if (beneficiario.idPersona != 0) {
      personas.push({
        InFiguraPersona: 3, //Beneficiario
        InCodAseg: beneficiario.codigoAsegurado,
        InCodPersona: beneficiario.idPersona,
        NmCodTipoDoc: beneficiario.tipoDocumento,
        SdFecExpDoc: beneficiario.fechaExpedicion,
        NmPjeParticipa: 0,
        NmVlrCupo: 0,
        SnPerPrincipal: 0,
        VcNroDoc: beneficiario.numeroDocumento.toString(),
        VcPrimerApellido: beneficiario.apellidoUno,
      });
    }

    return personas;
  }

  obtenerAmparos(emision: Poliza) {
    let amparos = emision.producto.amparos.map((x, i) => {
      return {
        InCodDeducible: x.cod_deducible ? x.cod_deducible : 0,
        NmCodRamoTec: x.codigo_ramo_tec,
        NmCodSubRamo: x.codigo_subramo,
        NmCodObjeto: x.codigo_objeto,
        InCodAmparo: x.codigo_amparo,
        NmValorIva: 19,
        NmConsecutivoAmpPol: i + 1, //Autonumérico
        SdFecVigDesde: x.fecha_vigencia_desde,
        SdFecVigHasta: x.fecha_vigencia_hasta,
        InDiasVig: x.total_dias, //Fecha Vigencia Hasta - Fecha Vigencia Desde
        InSnSumaPje: x.suma_es_porcentaje ? -1 : 0, // 0 -> false, -1 -> true
        NmPjeContrato: parseInt(
          x.porcentaje_contrato ? x.porcentaje_contrato : "0"
        ),
        InTipoTasa: x.tipo_tasa, //Porcentaje (0-100), milaje (0-1000), importe (directo)
        NmTasa: parseFloat(x.vr_tasa_accesos.toString()), //Porcentaje Tasa
        InTipoCalculoPrima: x.tipo_calculo, // 1 -> prorrateado, 2 -> Prima Vigencia (Modificar API y consumo)
        NmValorAsegurado: this.extraerNumero(x.valor_asegurado),
        NmPrima: this.extraerNumero(x.valor_prima), //Valor de la prima
        NmValorPrima: this.extraerNumero(x.valor_prima), //Valor prima ajustado (Al momento de la emisión)
        VcEstado: "I",
      };
    });
    return amparos;
  }

  obtenerIntermediarios(emision: Poliza) {
    let intermediarios = emision.intermediarios.map((x, i) => {
      return {
        InCodTipoAgente: x.cod_tipo_inter, //Tipo Agente
        InCodAgente: parseInt(x.clave),
        NmPjeParticipa:
          x.porcentaje_participacion != null ? x.porcentaje_participacion : 0,
        NmPjeComisNormal:
          x.porcentaje_comision != null ? x.porcentaje_comision : 0,
        NmPjeComisExtra: 0, //Siempre va a ser 0
        InSnPrincipal: i == 0 ? -1 : 0, //El primero es el principal (0 -> false, -1 -> true)
      };
    });
    return intermediarios;
  }

  consultarIva() {
    return 19;
  }

  async consultarConsorcio(codigoAsegurado: number) {
    let url = new URL(`${environment.backendUrl}/api/Consorcio/Consultar`);
    let parameters = {
      cod_asegurado_ppal: codigoAsegurado,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async asociarParticipanteConsorcio(
    tomador: Persona,
    participante: Participante
  ) {
    let url = new URL(`${environment.backendUrl}/api/Consorcio/Crear`);
    let parameters = {
      cod_asegurado_ppal: tomador.codigoAsegurado,
      cod_asegurado_cons: participante.codigoAsegurado,
      id_persona: participante.idPersona,
      pje_participacion: participante.porcentajeParticipacion,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    let object = await (await fetch(url.toString(), { method: "GET" })).json();
    return object;
  }

  async imprimirPoliza(Policy, token): Promise<Observable<any>> {
    let url = `${environment.backendUrlImpresion}/api/PrintingTemplates/Policy`;
    let s = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });
    return this.http.post(url, Policy, {
      headers: s,
      responseType: "json",
      withCredentials: true,
    });
  }

  async imprimirComprobante(Voucher, token) {
    let url = `${environment.backendUrlImpresion}/api/PrintingTemplates/Voucher`;
    let s = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });
    return this.http.post(url, Voucher, {
      headers: s,
      responseType: "json",
      withCredentials: true,
    });
  }

  async obtenerToken(authUser): Promise<Observable<any>> {
    //console.log("JSONTOken",authUser);
    let url = `${environment.backendUrlImpresion}/api/Auth/GetToken`;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let s = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http.post(url, authUser, { headers: s, responseType: "json" });
  }

  async EncriptPassword(): Promise<Observable<any>> {
    let s = new HttpHeaders({
      "Content-Type": "text/plain; charset=utf-8",
    });
    let url = `${environment.backendUrlImpresion}/api/Auth/Encrypt`;
    let queryParams = new HttpParams().append(
      "textToEncrypt",
      "$0l1d4r14@4p1Pe0ple"
    );
    return this.http.get(url, {
      headers: s,
      params: queryParams,
      responseType: "text",
    });
  }

  async obtenerTerceroAfectado() {
    let url = new URL(`${environment.backendUrl}/api/Parametro`);
    let parameters = {
      id_parametro: 927,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    return await (await fetch(url.toString(), { method: "GET" })).json();
  }

  async obtenerDuplicados(tipoDocumento: number, numeroDocumento: number) {
    let url = new URL(
      `${environment.backendUrl}/api/ClsUsuario/ConsultaPersonasDoc`
    );
    let parameters = {
      InTipoDocumento: tipoDocumento,
      StrNroDocumento: numeroDocumento,
      CrTipoPersona: "A",
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    return await (await fetch(url.toString(), { method: "GET" })).json();
  }

  async obtenerTiposEmpresa(codigoTipoAsociado: number) {
    let url = new URL(`${environment.backendUrl}/api/TipoEmpresa`);
    let parameters = {
      cod_tipo_asoc: codigoTipoAsociado,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    return await (await fetch(url.toString(), { method: "GET" })).json();
  }

  async obtenerTiposAsociado() {
    let url = `${environment.backendUrl}/api/TipoAsociado/TipoAsociado`;
    return await (await fetch(url, { method: "GET" })).json();
  }

  async obtenerValidacionesGobernabilidad(idPersona: number) {
    let url = new URL(
      `${environment.backendUrl}/api/TipoAsociado/ValidaAsociado`
    );
    let parameters = {
      id_persona: idPersona,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    return await (await fetch(url.toString(), { method: "GET" })).json();
  }

  async guardarGobernabilidad(
    persona: PersonaGobernabilidad,
    idPersonaJuridica: number,
    codigoUsuario: string
  ) {
    let gobernabilidad = {
      InId_persona: idPersonaJuridica,
      InCod_tipo_doc: persona.tipoDocumento,
      VcNro_doc: persona.numeroDocumento,
      VcTxt_nombre: persona.primerNombre,
      VcTxt_nombre2: persona.segundoNombre,
      VcTxt_apellido1: persona.primerApellido,
      VcTxt_apellido2: persona.segundoApellido,
      InCod_tipo_asoc: persona.tipoPersona,
      InPje_participacion: persona.porcentajeParticipacion,
      VcCod_ttipo_empresa: persona.tipoEmpresa
        ? persona.tipoEmpresa.toString()
        : null,
      InSn_exclusion: persona.exclusion ? -1 : 0,
      InSn_activo: -1,
      SdFec_inactivo: "01/05/2021",
      InSn_nuevo: -1,
      VcCod_usuario: codigoUsuario,
    };
    let json = JSON.stringify(gobernabilidad);
    let request: RequestInit = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
      },
      method: "POST",
      body: json,
    };
    let url = `${environment.backendUrl}/api/Gobernabilidad/GuardarGobernabilidad`;
    return (await (await fetch(url, request)).text()) == "true" ? true : false;
  }

  async validarPoliza(
    ramo: number = 0,
    sucursal: number = 0,
    numeroPoliza: number = 0
  ) {
    let url = new URL(
      `${environment.backendUrlEmision}/api/ImprimirPoliza/ValidarPoliza`
    );
    const parameters = {
      cod_ramo: ramo,
      cod_suc: sucursal,
      nro_poliza: numeroPoliza,
    };
    Object.keys(parameters).forEach((key) =>
      url.searchParams.append(key, parameters[key])
    );
    return await (await fetch(url.toString(), { method: "GET" })).json();
  }

  async getClientIP() {
    //const ipResponse = await this.http
      //.get("https://api.ipify.org?format=json")
      //.toPromise();
    //const clientIP = ipResponse["ip"];
    return '124.123.123';
  }

  
  validarExclusion(data: ValidacionExclusionRequestDto): Observable<ValidacionExclusionResponse> {
    const url = `${this.apiUrlValidate}/api/ValidacionExclusiones/validar`;
    return this.http.post<ValidacionExclusionResponse>(url, data);
  }

  //**************************** API Risk Methods ************************************
  async AuthorizeRisk(): Promise<Observable<any>> {
    const credentials = {
      User: `${environment.APIRiskUserName}`,
      Password: `${environment.APIRiskPassword}`,
    };

    let json = JSON.stringify(credentials);
    let url = `${environment.APIRiskBaseUrl}${environment.APIRiskTokenUrl}`;
    let s = new HttpHeaders({
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
    });
    return await this.http.post(url, json, { headers: s, responseType: "json" });
  }

  async ValidatePersonRisk(
    validaRisk: RiskRequest, token : string
  ): Promise<Observable<any>> {
    let url = `${environment.APIRiskBaseUrl}${environment.APIRiskValidateRiskUrl}`;
    let jsonValidaRisk = JSON.stringify(validaRisk);
    let s = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      });
      return this.http.post(url, jsonValidaRisk, {
        headers: s,
        responseType: "json",
        withCredentials: true,
      });
  }
}
